<template>
  <div class="password-requirements p-2 body-bg border" v-if="requirements && password">
    <div class="password-requirement-item"
         :class="{ met: minLengthMet }">
      <span class="password-requirement-icon">{{ minLengthMet ? '✓' : '✕' }}</span>
      {{ $t('password_requirement_min_length', { min: requirements.min_length }) }}
    </div>
    <div class="password-requirement-item"
         v-if="requirements.require_number"
         :class="{ met: hasNumber }">
      <span class="password-requirement-icon">{{ hasNumber ? '✓' : '✕' }}</span>
      {{ $t('password_requirement_number') }}
    </div>
    <div class="password-requirement-item"
         v-if="requirements.require_symbol"
         :class="{ met: hasSymbol }">
      <span class="password-requirement-icon">{{ hasSymbol ? '✓' : '✕' }}</span>
      {{ $t('password_requirement_symbol') }}
    </div>
    <div class="password-requirement-item"
         v-if="requirements.require_mixed_case"
         :class="{ met: hasMixedCase }">
      <span class="password-requirement-icon">{{ hasMixedCase ? '✓' : '✕' }}</span>
      {{ $t('password_requirement_mixed_case') }}
    </div>
  </div>
</template>

<script setup>
import {computed} from "vue"
import {useStore} from "vuex"

const props = defineProps({
  password: {
    type: String,
    default: ''
  }
})

const store = useStore()

const requirements = computed(() => store.state.auth.passwordRequirements)

const minLengthMet = computed(() => (props.password || '').length >= (requirements.value?.min_length || 0))
const hasNumber = computed(() => /\d/.test(props.password || ''))
const hasSymbol = computed(() => /[^a-zA-Z0-9]/.test(props.password || ''))
const hasMixedCase = computed(() => /[a-z]/.test(props.password || '') && /[A-Z]/.test(props.password || ''))
</script>

<style scoped lang="scss">
.password-requirements {
  border: 1px solid $gray-icon;
  border-radius: 5px;
}
.password-requirement-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: $danger-red;
  &.met {
    color: $green-color;
  }
}
.password-requirement-icon {
  font-weight: bold;
  width: 14px;
  text-align: center;
  flex-shrink: 0;
}
</style>
